export default {
  methods: {
    getFormattedDate(dateString) {
      let [date, time] = dateString.split(" ");
      if (!date) {
        return;
      }
      time = time ? " " + time.slice(0, 8) : ""; //миллисекунды не берем
      let dateArr = date.split("-");
      return dateArr.reverse().join(".") + time;
    },
  },
};
